import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SafeHtmlPipe } from '@shared/pipes';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackBarInfo } from '@interfaces';
import { LowerCasePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'sky-simple-snackbar',
  imports: [SafeHtmlPipe, LowerCasePipe, MatButton, TranslocoDirective],
  templateUrl: './simple-snackbar.component.html',
  styles: `
    ::ng-deep {
      .mdc-snackbar__label {
        padding-top: 8px;
        padding-bottom: 8px;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleSnackbarComponent {
  private readonly snackRef = inject(MatSnackBarRef<SimpleSnackbarComponent>);
  data: SnackBarInfo = inject(MAT_SNACK_BAR_DATA);

  cancel() {
    this.snackRef.dismissWithAction();
  }
}
